import client from './client';

export const fetchUser = (userId) => client.get(`/api/users/${userId}`);

export const fetchUserDues = (userId) => client.get(`/api/users/${userId}/dues`);

export const createDues = (userId, payload) => client.post(`/api/users/${userId}/dues`, payload);

export const lookupMemberByQrReference = (reference) => client.get('/api/users/lookup/qr-reference', {
	params: { ref: reference },
});

export const fetchUserNotifications = (userId, params) => client.get(`/api/users/${userId}/notifications`, {
	params,
});

export const markUserNotificationRead = (userId, notificationId) => client.patch(
	`/api/users/${userId}/notifications/${notificationId}/read`,
);

export const markAllUserNotificationsRead = (userId) => client.post(
	`/api/users/${userId}/notifications/mark-all-read`,
);

export const deleteUserNotification = (userId, notificationId) => client.delete(
	`/api/users/${userId}/notifications/${notificationId}`,
);
